<template>
  <base-modal
    :ref="modal.key"
    :title="modal.title"
    :show="open"
    @on-confirm="save"
    @on-cancel="hide()"
    :okText="$t('Save')"
    :closeText="$t('Close')"
    :maxWidth="700"
  >
    <v-form class="mt-5">
      <v-file-input
        v-model="model.image"
        accept="image/*"
        v-bind:label="$t('IncludeImage')"
        v-if="isBookmark"
      ></v-file-input>
      <BaseIconPicker
        :label="$t('Icon')"
        v-model="model.icon"
        v-if="isBookmark"
      />
      <v-select
        v-bind:label="$t('Periodicity')"
        v-model="model.periodicity"
        :items="periodicityList"
        item-text="text"
        item-value="id"
        v-if="isUploadedDocumentsChart"
      ></v-select>
      <v-select
        v-bind:label="$t('Quantity')"
        v-model="model.periodicityAmount"
        :items="periodicityAmountList"
        v-if="isUploadedDocumentsChart"
      ></v-select>
      <v-select
        v-bind:label="$t('Type')"
        v-model="model.bookmarkType"
        :items="bookmarkTypeList"
        item-text="text"
        item-value="id"
        v-if="isBookmark"
        @change="onBookmarkTypeChange()"
      ></v-select>
      <v-select
        v-bind:label="$t('Target')"
        v-model="model.target"
        :items="targetList"
        item-text="text"
        item-value="id"
        v-if="isBookmark"
      ></v-select>
      <v-text-field
        v-bind:label="$t('Description')"
        v-model="model.description"
        v-if="showDescription"
      ></v-text-field>
      <v-text-field
        v-bind:label="$t('Url')"
        v-model="model.url"
        v-if="isBookmark && isBookmarkLink"
      ></v-text-field>
      <v-text-field
        v-bind:label="$t('Title')"
        v-model="widgetTitle"
        v-if="isUserSearches || isNote || isDistributions || isSearchHistory"
      ></v-text-field>
      <v-select
        :loading="loadingLinkList"
        v-bind:label="$t('SelectItem')"
        v-model="model.url"
        :items="linkList"
        item-text="text"
        item-value="id"
        v-if="isBookmark && !isBookmarkLink"
      ></v-select>

      <ColorPicker
        :label="$t('Color')"
        v-model="model.color"
        v-if="showColor"
      />

      <ColorPicker
        :label="$t('TextColor')"
        v-model="model.textColor"
        v-if="showTextColor"
      />

      <BaseDualList
        :source="availableUserSearchesList"
        :destination="model.userSearchesToShow"
        item-text="text"
        item-id="id"
        @onChangeList="onUserSearchesListChange"
        v-if="isUserSearches"
      />
    </v-form>
  </base-modal>
</template>
<script>
import WidgetService from "@/services/WidgetService";
import WidgetSettings from "@/ecm/models/WidgetSettings";
import WidgetType from "@/ecm/variables/WidgetType";
import ColorPicker from "@/components/widgets/ColorPicker";
import SearchService from "@/services/SearchService";
import Utils from "@/ecm/common/Utils";

export default {
  components: { ColorPicker },
  data() {
    return {
      files: [],
      periodicityList: [
        { id: "Y", text: this.$t("Years") },
        { id: "M", text: this.$t("Months") },
        { id: "D", text: this.$t("Days") },
      ],
      periodicityAmountList: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
      ],
      loadingLinkList: false,
      bookmarkTypeList: [
        { id: 0, text: this.$t("Link") },
        { id: WidgetType.Baskets, text: this.$t("Baskets") },
        {
          id: WidgetType.UserSearches,
          text: this.$t("SavedSearches"),
        },
        {
          id: WidgetType.Distributions,
          text: this.$t("DistributionInternalExternal"),
        },
      ],
      linkList: [],
      availableUserSearchesList: [],
      targetList: [
        { id: "_blank", text: this.$t("NewWindow") },
        { id: "_self", text: this.$t("SameWindow") },
      ],
      id: 0,
      model: new WidgetSettings(),
      modal: {
        title: this.$t("Settings"),
        key: "userModal",
      },
      open: false,
    };
  },
  computed: {
    modalInstance() {
      return this.$refs[this.modal.key];
    },
    isUploadedDocumentsChart() {
      return this.model.widgetId == WidgetType.UploadedDocumentsChart;
    },
    isSearchHistory() {
      return this.model.widgetId == WidgetType.SearchHistory;
    },
    isUserSearches() {
      return this.model.widgetId == WidgetType.UserSearches;
    },
    isDistributions() {
      return this.model.widgetId == WidgetType.Distributions;
    },
    isNote() {
      return this.model.widgetId == WidgetType.Note;
    },
    isBookmark() {
      return this.model.widgetId == WidgetType.Bookmark;
    },
    showDescription() {
      return this.model.widgetId == WidgetType.Bookmark;
    },
    isBookmarkLink() {
      return this.model.bookmarkType == 0;
    },
    showColor() {
      return (
        this.model.widgetId == WidgetType.Bookmark ||
        this.model.widgetId == WidgetType.Note ||
        this.model.widgetId == WidgetType.UserSearches ||
        this.model.widgetId == WidgetType.Distributions ||
        this.model.widgetId == WidgetType.SearchHistory
      );
    },
    showTextColor() {
      return (
        this.model.widgetId == WidgetType.Bookmark ||
        this.model.widgetId == WidgetType.Note ||
        this.model.widgetId == WidgetType.SearchHistory
      );
    },
    widgetTitle: {
      get() {
        if (this.model.widgetTitle) {
          return this.model.widgetTitle;
        } else {
          switch (this.model.widgetId) {
            case WidgetType.UserSearches:
              return this.$t("SavedSearches");
            case WidgetType.Distributions:
              return this.$t("DistributionInternalExternal");
            case WidgetType.SearchHistory:
              return this.$t("WidgetSearchHistoryTitle");
          }
          return "";
        }
      },
      set(val) {
        this.model.widgetTitle = val;
      },
    },
  },
  methods: {
    async save() {
      this.modalInstance.progress(true);

      if (this.model.image && typeof this.model.image == "object") {
        var image = await Utils.file.toBase64(this.model.image);
        this.model = { ...this.model, image: image };
      }
      const model = Object.assign(new WidgetSettings(), this.model);

      if (this.model.widgetId === WidgetType.UserSearches) {
        let ids = this.model.userSearchesToShow.map(t => parseInt(t.id));
        let ordered = ids.every(function (x, i) { return i === 0 || x >= ids[i - 1] });

        if (ordered && this.availableUserSearchesList.length === 0) {
          model.userSearchesToShow = [];
        }
      }

      let widgetDto = {
        Id: this.id,
        WidgetID: model.widgetId,
        Settings: model.toDto(),
      };

      WidgetService.updateSettings(widgetDto)
        .then((data) => {
          this.open = false;
          this.$emit("on-save", model.toDto());
        })
        .catch((error) => {
          // error
        })
        .then(() => {
          //always
          this.modalInstance.progress(false);
        });
    },
    show(id, widgetId, dto) {
      this.id = id;
      this.model = new WidgetSettings(widgetId, dto);
      this.loadData();
      this.open = true;
    },
    hide() {
      this.open = false;
    },
    userSavedSearches() {
      return this.$store.getters["account/userSavedSearches"];
    },
    loadData() {
      if (this.model.widgetId == WidgetType.Bookmark) {
        this.onBookmarkTypeChange(this.model.url);
      } else if (this.model.widgetId == WidgetType.UserSearches) {
        let availableUserSearches = this.$store.getters[
          "account/userSavedSearches"
        ]
          .filter(
            (d) => !this.model.userSearchesToShow.some((us) => d.Id == us.id)
          )
          .map((d) => {
            return { id: d.Id + "", text: d.FilterName };
          });


        let selectedUserSearches = this.$store.getters[
          "account/userSavedSearches"
        ]
          .filter(
            (d) => this.model.userSearchesToShow.some((us) => d.Id == us.id)
          )
          .map((d) => {
            return { id: d.Id + "", text: d.FilterName };
          });

        if (selectedUserSearches.length === 0) {
          this.availableUserSearchesList = [];
          this.model.userSearchesToShow = availableUserSearches;
        }
        else {
          this.availableUserSearchesList = availableUserSearches;
          this.model.userSearchesToShow = selectedUserSearches.sort((a, b) => this.getIndexById(a.id) - this.getIndexById(b.id));;
        }
      }
    },
    getIndexById(id) {
      return this.model.userSearchesToShow.findIndex((obj) => obj.id === id);
    },
    onBookmarkTypeChange(currentUrl) {
      let url = currentUrl || "";

      if (this.model.bookmarkType > 0) {
        this.loadingLinkList = true;
        WidgetService.getData({
          WidgetID: this.model.bookmarkType,
        }).then((data) => {
          this.linkList = data.map((d) => {
            return { id: d.Id + "", text: d.Description };
          });

          this.model = { ...this.model, url: url };
          this.loadingLinkList = false;
        });
      } else {
        this.model = { ...this.model, url: url };
      }
    },
    onUserSearchesListChange: function ({ destination, source }) {
      this.availableUserSearchesList = source;
      this.model.userSearchesToShow = destination;
    },
  },
};
</script>